var lg_MKJ32022805_VCR = {
    name: "MKJ32022805_VCR",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [68,0,4,90,2,254,1,90,2,109,6,89,35,98,17,88,2,101,156,53,107,123,187,122,218,162],
        },
        {
            // function: "sourcevcr",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [68,0,4,90,2,254,1,90,2,109,6,89,35,98,17,88,2,101,156,53,107,123,173,190,218,162],
        },
        {
            function: "stopvcr",
            name: "stopvcr",
            icon: "stopvcr",
            command: [68,0,4,90,2,254,1,90,2,109,6,89,35,98,17,88,2,101,156,53,107,123,175,250,170,162],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [68,0,4,90,2,254,1,90,2,109,6,89,35,98,17,88,2,101,156,53,107,123,189,245,106,162],
        },
        {
            function: "pausevcr",
            name: "pausevcr",
            icon: "pausevcr",
            command: [68,0,4,90,2,254,1,90,2,109,6,89,35,98,17,88,2,101,156,53,107,123,171,127,106,162],
        },
        {
            function: "KEY_RECORD",
            name: "KEY_RECORD",
            icon: "KEY_RECORD",
            command: [68,0,4,90,2,254,1,90,2,109,6,89,35,98,17,88,2,101,156,53,107,123,174,253,106,162],
        },
        {
            function: "<<vcr",
            name: "<<vcr",
            icon: "<<vcr",
            command: [68,0,4,90,2,254,1,90,2,109,6,89,35,98,17,88,2,101,156,53,107,123,183,246,170,162],
        },
        {
            function: ">>vcr",
            name: ">>vcr",
            icon: ">>vcr",
            command: [68,0,4,90,2,254,1,90,2,109,6,89,35,98,17,88,2,101,156,53,107,123,171,254,170,162],
        },
        {
            function: "KEY_1vcr",
            name: "KEY_1vcr",
            icon: "KEY_1vcr",
            command: [68,0,4,90,2,254,1,90,2,109,6,89,35,98,17,88,2,101,156,53,107,123,173,253,170,162],
        },
        {
            function: "KEY_2vcr",
            name: "KEY_2vcr",
            icon: "KEY_2vcr",
            command: [68,0,4,90,2,254,1,90,2,109,6,89,35,98,17,88,2,101,156,53,107,123,181,251,170,162],
        },
        {
            function: "KEY_3vcr",
            name: "KEY_3vcr",
            icon: "KEY_3vcr",
            command: [68,0,4,90,2,254,1,90,2,109,6,89,35,98,17,88,2,101,156,53,107,123,170,255,170,162],
        },
        {
            function: "KEY_4vcr",
            name: "KEY_4vcr",
            icon: "KEY_4vcr",
            command: [68,0,4,90,2,254,1,90,2,109,6,89,35,98,17,88,2,101,156,53,107,123,186,250,234,162],
        },
        {
            function: "KEY_5vcr",
            name: "KEY_5vcr",
            icon: "KEY_5vcr",
            command: [68,0,4,90,2,254,1,90,2,109,6,89,35,98,17,88,2,101,156,53,107,123,173,126,234,162],
        },
        {
            function: "KEY_6vcr",
            name: "KEY_6vcr",
            icon: "KEY_6vcr",
            command: [68,0,4,90,2,254,1,90,2,109,6,89,35,98,17,88,2,101,156,53,107,123,181,125,234,162],
        },
        {
            function: "KEY_7vcr",
            name: "KEY_7vcr",
            icon: "KEY_7vcr",
            command: [68,0,4,90,2,254,1,90,2,109,6,89,35,98,17,88,2,101,156,53,107,123,170,191,234,162],
        },
        {
            function: "KEY_8vcr",
            name: "KEY_8vcr",
            icon: "KEY_8vcr",
            command: [68,0,4,90,2,254,1,90,2,109,6,89,35,98,17,88,2,101,156,53,107,123,186,189,122,162],
        },
        {
            function: "KEY_9vcr",
            name: "KEY_9vcr",
            icon: "KEY_9vcr",
            command: [68,0,4,90,2,254,1,90,2,109,6,89,35,98,17,88,2,101,156,53,107,123,173,95,122,162],
        },
        {
            function: "KEY_0vcr",
            name: "KEY_0vcr",
            icon: "KEY_0vcr",
            command: [68,0,4,90,2,254,1,90,2,109,6,89,35,98,17,88,2,101,156,53,107,123,187,245,170,162],
        },
    ]
}
export default lg_MKJ32022805_VCR